<script>
    import {apiUrl} from '../config.svelte';
    import {Button} from 'sveltestrap';
    export let user = {};
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    function doLogout(){
        fetch(apiUrl+"logout",{
            credentials:'include',
            method:"POST",
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{if(x.result){
            dispatch('loggedOff', { });
        }})
    }
</script>

<div style="float:left;margin-top:0px;margin-left:0px;left:0px;width:100%;height:42px;background-color:black;color:white;padding:2px;">
    <div style="float:left"><Button on:click={()=>{window.location="/"}} color="dark">Главная</Button></div>

    <div style="float:right;">
        <div style="float:right">
            <Button on:click={()=>{doLogout()}} color="dark">Выйти</Button>
        </div>
        <div style="float:right;padding:6px;margin-right:15px;">
            {user.FirstName} {user.LastName}
        </div>
    </div>
</div>